<div class="menu-switcher">
  <mat-slide-toggle (change)="changeMenu($event)">Old Menu</mat-slide-toggle>
</div>
